import type { jsPDF } from "jspdf";
import { Box } from "../layout/box.ts";
import { BaseElement } from "./baseElement";

export class Text2D extends BaseElement {
	kind = "text2d" as const;
	color: string;
	fontFamily: string;
	fontWeight: string;
	fontSize: number;
	text: string;
	maxWidth: number = Number.MAX_VALUE;
	centered: boolean;
	lineHeight?: number;

	constructor(
		box: Box,
		id: string,
		fontFamily: string,
		fontWeight: string,
		fontSize: number,
		text: string,
		color: string,
		centered?: boolean,
		lineHeight?: number
	) {
		super(box, id);
		this.fontFamily = fontFamily;
		this.fontWeight = fontWeight;
		this.fontSize = fontSize;
		this.color = color;
		this.text = text;
		this.centered = centered ?? false;
		this.lineHeight = lineHeight;
	}

	async calculate(jsPdf: jsPDF) {
		if (this.maxWidth < this.box.size.width) {
			this.box.size.width = this.maxWidth;
		}
		jsPdf.setFont(this.fontFamily, this.fontWeight);
		jsPdf.setFontSize(this.fontSize);
		const lines = jsPdf.splitTextToSize(this.text, this.box.size.width);
		const fontHeight = jsPdf.getFontSize() / jsPdf.internal.scaleFactor;
		if (this.box.size.height == 0) {
			const multiplier = this.lineHeight ?? 1.0;
      this.box.size.height = lines.length * (fontHeight * multiplier);
		}
	}

	async draw(pdfDocument: jsPDF): Promise<void> {
		if (this.box.backgroundColor) {
			const box = this.box.getBoundingBox();
			pdfDocument.setFillColor(this.box.backgroundColor);
			pdfDocument.rect(box.x, box.y, box.width, box.outerHeight, "F");
		}

		pdfDocument.setTextColor(this.color);
		pdfDocument.setFont(this.fontFamily, this.fontWeight);
		pdfDocument.setFontSize(this.fontSize);
		const box = this.box.getBoundingBox();
		const lines = pdfDocument.splitTextToSize(this.text, this.box.size.width);
		const textSize = pdfDocument.getFontSize() / pdfDocument.internal.scaleFactor;

		const multiplier = this.lineHeight ?? 1.0;
    const lineSpacing = textSize * multiplier;

		let xAxis = box.x;
		let yAxis = box.y;

		if (lines.length > 1) {
			for (const [index, line] of lines.entries()) {
				if (this.centered) {
					const totalBoxWidth = box.outerWidth;
					const centeredX = totalBoxWidth / 2;
					const centeredX2 = pdfDocument.getTextWidth(line) / 2;
					xAxis = box.x + (centeredX - centeredX2);
					const totalHeight = box.outerHeight;
					const centeredY = totalHeight / 2;
					const centeredY2 = textSize / 2;
					yAxis = box.y + (centeredY - centeredY2) - textSize / 2;
				}
				// pdfDocument.setDrawColor(0, 0, 0);
				// pdfDocument.rect(xAxis, box.y + textSize * index, pdfDocument.getTextWidth(line), box.outerHeight, "S");
				pdfDocument.text(line, xAxis, yAxis + (lineSpacing * index), { baseline: "top" });
			}
		} else {
			if (this.centered) {
				const totalBoxWidth = box.outerWidth;
				const centeredX = totalBoxWidth / 2;
				const centeredX2 = pdfDocument.getTextWidth(this.text) / 2;
				xAxis = box.x + (centeredX - centeredX2);
				const totalHeight = box.outerHeight;
				const centeredY = totalHeight / 2;
				const centeredY2 = textSize / 2;
				yAxis = box.y + (centeredY - centeredY2);
			}
			// pdfDocument.setDrawColor(0, 0, 0);
			// pdfDocument.rect(xAxis, box.y, pdfDocument.getTextWidth(this.text), box.outerHeight, "S");
			pdfDocument.text(this.text, xAxis, yAxis, { baseline: "top" });
		}
	}
}
